// Auto-generate Table of Contents from H2 headings
(function() {
  const content = document.querySelector('.article-template__content');
  if (!content) return;

  const headings = content.querySelectorAll('h2');
  if (headings.length < 3) return; // Only show ToC if 3+ sections

  // Add IDs to headings
  headings.forEach((h, i) => {
    if (!h.id) {
      h.id = 'section-' + (i + 1);
    }
  });

  // Build ToC HTML
  const toc = document.createElement('nav');
  toc.className = 'article-toc';
  toc.setAttribute('aria-label', 'Table of Contents');

  let html = '<div class="article-toc__header">';
  html += '<span class="article-toc__title">In This Article</span>';
  html += '<button class="article-toc__toggle" aria-expanded="true" aria-label="Toggle table of contents">';
  html += '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  html += '</button></div>';
  html += '<ol class="article-toc__list">';

  headings.forEach((h) => {
    // Skip "Recommended" and "Keep Reading" sections
    const text = h.textContent.trim();
    if (text.includes('Recommended') || text.includes('Keep Reading')) return;
    html += '<li><a href="#' + h.id + '">' + text + '</a></li>';
  });

  html += '</ol>';
  toc.innerHTML = html;

  // Insert before first H2
  const firstH2 = headings[0];
  if (firstH2) {
    firstH2.parentNode.insertBefore(toc, firstH2);
  }

  // Toggle functionality
  const toggle = toc.querySelector('.article-toc__toggle');
  const list = toc.querySelector('.article-toc__list');
  if (toggle && list) {
    toggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      list.style.display = expanded ? 'none' : '';
      this.querySelector('svg').style.transform = expanded ? 'rotate(-90deg)' : '';
    });
  }

  // Smooth scroll
  toc.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', this.getAttribute('href'));
      }
    });
  });

  // Active state on scroll
  let ticking = false;
  function updateActive() {
    const scrollPos = window.scrollY + 120;
    let current = null;
    headings.forEach(h => {
      if (h.offsetTop <= scrollPos) current = h.id;
    });
    toc.querySelectorAll('a').forEach(a => {
      a.classList.toggle('active', a.getAttribute('href') === '#' + current);
    });
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(updateActive);
      ticking = true;
    }
  });
})();
